// PLUGINS IMPORTS //
import React from "react"
import { Element } from "react-scroll"
import styled from "styled-components/macro"

// COMPONENTS IMPORTS //
import SectionWrapper from "Content/Shared/Components/Wrappers/SectionWrapper"

import Info from "./Info/Info"
import { memoComparison } from "Content/Shared/Helpers/Functions/Functions"

// EXTRA IMPORTS //
import PreviewImage from "Assets/Images/illustrations/sending_emails.png"
import { iPadResolution } from "Content/Shared/Styles/Theme"

/////////////////////////////////////////////////////////////////////////////

type PropsType = {
  wrapperStyle?: any
}

const ContactsSection: React.FC<PropsType> = (props) => {
  const title = "CONTACTS"

  return (
    <Element name={title} style={props.wrapperStyle}>
      <SectionWrapper title={title}>
        <Wrapper>
          <Info />
          <Image src={PreviewImage} />
        </Wrapper>
      </SectionWrapper>
    </Element>
  )
}

/////////////////////////////////////////////////////////////////////////////

const Wrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  margin-right: 80px;
  margin-left: 80px;

  @media (max-width: ${iPadResolution}px) {
    flex-direction: column;
    align-items: center;
  }
`

const Image = styled.img`
  width: 35%;

  @media (max-width: ${iPadResolution}px) {
    margin-top: 40px;
    margin-bottom: -70px;
    width: 46%;
  }
`

export default React.memo(ContactsSection, memoComparison)
